"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _states = require("../internal/validation/states");

var _useIncomingError = _interopRequireDefault(require("../internal/hooks/useIncomingError"));

var _InputWrapper = _interopRequireDefault(require("./components/InputWrapper"));

var _BasicTextInput = _interopRequireDefault(require("./components/BasicTextInput"));

var _MaskedTextInput = _interopRequireDefault(require("./components/MaskedTextInput"));

var _validationRules = require("./validationRules");
/** Field to enter freeform or formatted text
 */


var TextInput = function TextInput(props) {
  var appendChild = props.appendChild,
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      disabled = props.disabled,
      displayLabel = props.displayLabel,
      getError = props.getError,
      htmlId = props.htmlId,
      inputPrefix = props.inputPrefix,
      inputSuffix = props.inputSuffix,
      masking = props.masking,
      maxLength = props.maxLength,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      placeholder = props.placeholder,
      prependChild = props.prependChild,
      readOnly = props.readOnly,
      required = props.required,
      rows = props.rows,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties2["default"])(props, ["appendChild", "autoComplete", "autoFocus", "disabled", "displayLabel", "getError", "htmlId", "inputPrefix", "inputSuffix", "masking", "maxLength", "name", "onBlur", "onChange", "onFocus", "onKeyDown", "placeholder", "prependChild", "readOnly", "required", "rows", "type", "value"]);

  var _useState = (0, _react.useState)(_states.validState),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      validationState = _useState2[0],
      setValidationState = _useState2[1];

  var getValidation = function getValidation(_ref) {
    var value = _ref.value,
        repressError = _ref.repressError;
    return (0, _validationRules.validationRules)(props, repressError, value);
  };

  var prepareUnmaskedValue = function prepareUnmaskedValue(value) {
    return masking.mask ? unmask(value, masking) : value;
  };

  var incomingValidation = {
    value: prepareUnmaskedValue(value),
    repressError: true
  };
  (0, _useIncomingError["default"])(getValidation(incomingValidation).msg, !!getValidation(incomingValidation).type, setValidationState);

  var handleOnBlur = function handleOnBlur(event) {
    var value = prepareUnmaskedValue(event.target.value);
    setValidationState(getValidation({
      value: value,
      repressError: false
    }));
    if (onBlur) onBlur(event);
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (onKeyDown) onKeyDown(event);
  };

  var handleOnFocus = function handleOnFocus() {
    if (onFocus) onFocus();
  };

  var onTextInputChange = function onTextInputChange(event) {
    var value = prepareUnmaskedValue(event.target.value);
    var validation = getValidation({
      value: value,
      repressError: true
    });
    setValidationState(validation);
    onChange({
      target: {
        name: name,
        value: value
      }
    }, !validation.type, event);
  };

  var setCursorPosition = function setCursorPosition(event) {
    // Allows for content to be added to incomplete masked value when cursor is
    // placed after the placeholders '_', otherwise the field is unresponsive.
    var _event$target = event.target,
        selectionDirection = _event$target.selectionDirection,
        selectionEnd = _event$target.selectionEnd,
        selectionStart = _event$target.selectionStart,
        value = _event$target.value;

    if (masking.mask && selectionDirection === "forward" && selectionStart === maxLength && selectionEnd === maxLength && value.endsWith("_")) {
      var countNonEssential = value.match(/_/g, "").length;
      event.target.selectionStart = selectionStart - countNonEssential;
      event.target.selectionEnd = selectionEnd - countNonEssential;
    }

    handleOnKeyDown(event);
    return event;
  };

  return /*#__PURE__*/_react["default"].createElement(_InputWrapper["default"], (0, _objectSpread2["default"])({
    formControl: masking.mask ? /*#__PURE__*/_react["default"].createElement(_MaskedTextInput["default"], {
      onBlur: handleOnBlur,
      onTextInputChange: onTextInputChange,
      onFocus: handleOnFocus,
      onKeyDown: setCursorPosition,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      disabled: disabled,
      htmlId: htmlId,
      masking: masking,
      name: name,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required,
      type: type,
      value: value
    }) : /*#__PURE__*/_react["default"].createElement(_BasicTextInput["default"], Object.assign({
      onBlur: handleOnBlur,
      onTextInputChange: onTextInputChange,
      onFocus: handleOnFocus
    }, (0, _objectSpread2["default"])({
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      disabled: disabled,
      htmlId: htmlId,
      onKeyDown: onKeyDown,
      maxLength: maxLength,
      name: name,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required,
      rows: rows,
      type: type,
      value: value
    }, other))),
    appendChild: appendChild,
    displayLabel: displayLabel,
    inputPrefix: inputPrefix,
    inputSuffix: inputSuffix,
    prependChild: prependChild,
    validationState: validationState
  }, props));
};

function unmask(value, masking) {
  var mask = masking.mask,
      unmask = masking.unmask;
  var unmaskRegExp = new RegExp("[".concat(unmask.join(""), "]"), "g");
  var cleanValue = value.toString().replace(unmaskRegExp, "");

  if (typeof value === "number") {
    cleanValue = Number(cleanValue);
  }

  return mask ? cleanValue : value;
}

TextInput.defaultProps = {
  autoFocus: false,
  className: "textInput",
  disabled: false,
  displayLabel: true,
  layout: "vertical",
  masking: {
    guide: false
  },
  readOnly: false
};
var _default = TextInput;
exports["default"] = _default;